<template>
  <avtalat-input
    id="intern-kommentar"
    v-model:value="internKommentarModel"
    label="Intern kommentar"
    helpText="Interna kommentarer är ej synliga för kunden"
    type="textarea"
    :required="required"
    placeholder="Skriv en intern kommentar"
  />
  <FormErrorMessage name="internKommentar" />
  <InternaKommentarerList
    v-if="internaKommentarer?.length"
    :interna-kommentarer="internaKommentarer ?? []"
    :showVerified="showVerified"
    heading="Interna Kommentarer "
    :canEdit="canEdit"
  />
</template>

<script setup lang="ts">
import FormErrorMessage from "@/components/ui/FormErrorMessage.vue";
import type { IInternKommentar } from "@/composables/KundserviceAppApiClient";

import InternaKommentarerList from "../arende-components/InternaKommentarerList.vue";

const internKommentarModel = defineModel<string>();

defineProps<{
  required: boolean;
  internaKommentarer?: IInternKommentar[] | null | undefined;
  showVerified: boolean;
  canEdit: boolean;
}>();
</script>
